import { useEffect } from 'react';
import './App.css';
import Landing from './component/Landing';
import { HashRouter, Route, Routes, useLocation } from 'react-router-dom';
import Policy from './component/Policy';
import TermsConditions from './component/TermsConditions';
import { ToastContainer,Slide } from 'react-toastify';
import Shipping from './component/Shipping';
import Refund from './component/Refund';
import Contact from './component/Contact';
import Disclaimer from './component/Disclaimer';

// Start each page at the top, unless we're heading to a home-page section.
const ScrollToTop = () => {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (!state?.section) window.scrollTo(0, 0);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

function App() {
  return (
    <>
    <ToastContainer
     transition={Slide}
     theme='light'
    />
    <HashRouter>
      <ScrollToTop />
      {/* These URLs are registered in the Play Console and App Store Connect — do not rename or remove them. */}
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/privacypolicy' element={<Policy />} />
        <Route path='/privacy-policy' element={<Policy />} />
        <Route path='/terms-conditions' element={<TermsConditions />} />
        <Route path='/shipping' element={<Shipping />} />
        <Route path='/refund' element={<Refund />} />
        <Route path='/disclaimer' element={<Disclaimer />} />
        <Route path='/contactus' element={<Contact />} />
      </Routes>
    </HashRouter>
    </>
  );
}

export default App;
